'use client';
export { NotFoundError as default } from '@/components/errors/not-found-error/not-found-error';
